


















import {Vue, Component, PropSync, Watch, Prop} from 'vue-property-decorator';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import { Getter, namespace } from 'vuex-class';
import { Mall } from 'supporter';
import { ValueNameType } from '@/store/modules/orderEnums';

const orderEnumsModule = namespace('orderEnums');

@Component({
  components: {
    CompSelectBox
  }
})
export default class PayTypeCheckList extends Vue{
  private payTypeCheckList = []
  private isPayTypeCheckedAll = true

  @Getter('mall/malls')
  private malls: Mall[]
  @orderEnumsModule.Getter('payTypeMap')
  private readonly payTypeMap!: ValueNameType[];

  @Prop({required: true})
  private readonly mallNo!: undefined | number;

  @PropSync('payTypes')
  private payTypesSync!: string[]

  private isAllChecked(): void{
    this.$nextTick(()=>{
      this.isPayTypeCheckedAll = this.payTypesSync.length === this.payTypeCheckList.length
    })
  }

  private checkAll(): void{
    this.isPayTypeCheckedAll = !this.isPayTypeCheckedAll
    if(this.isPayTypeCheckedAll){
      this.payTypesSync = this.payTypeCheckList.map(payType => payType.value)
      return
    }

    this.payTypesSync = []
  }

  @Watch('mallNo')
  public async fetchAndSetPayTypesCheckList(){
    const mallNos = this.mallNo ? this.mallNo.toString() : this.malls.map(mall => mall.mallNo).join(',')
    const orderConfigResponse = await this.$api.getOrderConfigsOrder({
      params: {
        mallNos
      }
    })

    const SELECTED_MALL_INDEX = 0
    let enablePayTypes
    // 사용 가능 결제 수단 'mallNo가 선택되었을 때' vs 'mallNo가 전체 일 때'
    if(this.mallNo){
      enablePayTypes = orderConfigResponse.data[SELECTED_MALL_INDEX].value.enablePayTypes
    }else{
      //'mallNo가 전체 일 때' 사용 가능 결제 수단이 가장 많은 쇼핑몰의 enablePayTypes를 가져옴
      enablePayTypes = orderConfigResponse.data.sort((a,b) => b.value.enablePayTypes.length - a.value.enablePayTypes.length)[0].value.enablePayTypes
    }

    // 결제수단 select 아이템{name, value}으로 변환
    this.payTypeCheckList = enablePayTypes.map(enablePayType => this.payTypeMap.find(payType => payType.value === enablePayType)).filter(Boolean);
    const rentalType = this.payTypeMap.find(payType => payType.value === 'RENTAL');
    const pagesWithRentalPay = ['CancelList', 'ReturnList', 'RefundsList'];
    const hasRentalPay = pagesWithRentalPay.includes(this.$route.name);
    rentalType && hasRentalPay && this.payTypeCheckList.push(rentalType);
    this.reset();
  }

  public reset(){
    this.isPayTypeCheckedAll = false;
    this.checkAll();
  }

  private async created(){
    this.reset()
  }

}
